import { isMobile } from '../../../../core/helpers/isMobile';

export const RINGS = ['big', 'middle', 'small'];

export const matrixContainerParams = {
  xInFigma: isMobile() ? 325 : 704,
  yInFigma: isMobile() ? 104 : 387,
  barX: isMobile() ? 0 : 0,
  barY: isMobile() ? -108 : -213,
};

export const textSlotNames = {
  big: ['4.5x', '13.5x', '29.5x', '55x', '90x', '141x', '230x', 'bonus'],
  middle: ['2.65x', '8.25x', '16.5x', '29x', '47x', '+22.5x'],
  small: ['1.75x', '5.25x', '11x', '+7.5x'],
};
// export const shakePath = 'M 0 0 Q 0 1 0 19 Q 0 1 0 0';
// export const shakePath = 'M 0 0 Q -1 0 0 5 Q 1 5 0 10 Q -1 5 0 5 Q 1 0 0 0';
export const shakePath = 'M 0 0 Q -2 0 0 7 Q 2 7 0 14 Q -2 7 0 7 Q 2 0 0 0';
// const dropPath = 'M 0 0 Q 0 1 0 19 Q 0 1 0 0';

export const bordersInLoaderSlotNames = {
  big: ['r1Separ1', 'r1Separ2', 'r1Separ3', 'r1Separ4', 'r1Separ5', 'r1Separ6', 'r1Separ7'],
  middle: ['r2Separ1', 'r2Separ2', 'r2Separ3', 'r2Separ4', 'r2Separ5'],
  small: ['r3Separ1', 'r3Separ2', 'r3Separ3'],
};

export const matrixReverseLoadingImageNames = {
  big: ['R1nw1', 'R1nw2', 'R1nw3', 'R1nw4', 'R1nw5', 'R1nw6', 'R1nw7', 'R1nw8'],
  middle: ['R2nw1', 'R2nw2', 'R2nw3', 'R2nw4', 'R2nw5', 'R2nw6'],
  small: ['R3nw1', 'R3nw2', 'R3nw3', 'R3nw4'],
};

export const barFXAnimationNames = {
  big: 'blue',
  middle: 'green',
  small: 'red',
};

export const lightLoaderSlotNames = {
  big: 'strip1Light',
  middle: 'strip2Light',
  small: 'strip3Light',
};

export const textSlotsAlphaEnablingScaleValues = {
  big: [0.165, 0.385, 0.63, 0.85, 1.095, 1.33, 1.575, 1.81],
  middle: [0.2, 0.43, 0.66, 0.93, 1.17, 1.43],
  small: [0.2, 0.46, 0.73, 1],
};

export const scaleOffsetForNoWinAnimation = 0.08;
export const noWinScaleDuration = 0.1;

export const ringMaxStates = {
  big: 8,
  middle: 6,
  small: 4,
};

export const ringCashOutStates = {
  big: 7,
  middle: 5,
  small: 3,
};

export const lineNamesInBackEnd = {
  0: 'line3',
  1: 'line2',
  2: 'line1',
};

export const lineBigStates = {
  0: 'zero',
  1: '4.5',
  2: '13.5',
  3: '29.5',
  4: '55',
  5: '90',
  6: '141',
  7: '230',
  8: 'BONUS',
};

export const lineBigStatesScale = {
  0: 0.02,
  1: 0.243,
  2: 0.481,
  3: 0.72,
  4: 0.956,
  5: 1.195,
  6: 1.433,
  7: 1.65,
  8: 1.88,
};

export const lineMiddleStates = {
  0: 'zero',
  1: '2.65',
  2: '8.25',
  3: '16.5',
  4: '29',
  5: '47',
  6: '22.5',
};

export const lineMiddleStatesScale = {
  0: 0.02,
  1: 0.255,
  2: 0.507,
  3: 0.758,
  4: 1.01,
  5: 1.26,
  6: 1.5,
};

export const lineSmallStates = {
  0: 'zero',
  1: '1.75',
  2: '5.25',
  3: '11',
  4: '7.5',
};

export const lineSmallStatesScale = {
  0: 0.02,
  1: 0.281,
  2: 0.558,
  3: 0.837,
  4: 1.1,
};
